import { TinyDropdownMenu } from '@octopus-do/octopus-storybook'
import { Envelope, Link, Pen, Trash } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

interface Props {
  canEdit: boolean
  canDelete: boolean
  canMarkUnread: boolean
}

export const Content: React.FC<Props> = ({
  canEdit,
  canDelete,
  canMarkUnread,
}) => (
  <>
    {canEdit && (
      <>
        <TinyDropdownMenu.Group>
          <TinyDropdownMenu.Button id="edit" label="Edit" icon={Pen} />
        </TinyDropdownMenu.Group>
        <TinyDropdownMenu.Divider />
      </>
    )}
    <TinyDropdownMenu.Group>
      <TinyDropdownMenu.Button id="copy-link" label="Copy link" icon={Link} />
      {canMarkUnread && (
        <TinyDropdownMenu.Button
          id="mark-unread"
          label="Mark as unread"
          icon={Envelope}
        />
      )}
      {canDelete && (
        <TinyDropdownMenu.Button
          id="delete"
          label="Delete thread"
          icon={Trash}
          variant="danger"
        />
      )}
    </TinyDropdownMenu.Group>
  </>
)
